export default "__VITE_ASSET__Dn7_3ZVG__"